import { trackEvent } from './track-event'

type Item = {
  target: string
  source: string
}
export function trackClickRecommendationHdp(items: Item[]) {
  trackEvent({
    event: 'click_recommendation_hdp',
    ecommerce: { items },
  })
}
